module.exports = __webpack_public_path__ + "img/s1_t1_04.0595d4b7.jpeg";